import { uuid } from 'uuidv4';

const newAvailability = (type, start, end, groupArr) => {
  return {
    type,
    id: uuid(),
    time: {
      start: start,
      end: end
    },
    raw: {
      group: groupArr
    }
  };
};

export default newAvailability;